// components/JobForm.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import jbAPI from "../../api/jobboard";
import "../../assets/css/jobform.css";

const JobForm = ({ onSubmit, initialValues = {}, isEdit = false }) => {
  const token = localStorage.getItem("otoken");
  const fullName = localStorage.getItem("name");
  const email = localStorage.getItem("email");
  const companyName = localStorage.getItem("companyName");
  const [message, setMessage] = useState({ type: "", text: "" });
  const location = useLocation();
  const { id } = useParams();
  const categorySpecializations = {
    "Software Development": [
      "Full Stack Development",
      "Frontend Development",
      "Backend Development",
      "Mobile App Development",
      "DevOps",
      "QA Testing",
    ],
    "Data & AI": [
      "Data Science",
      "Data Engineering",
      "Machine Learning",
      "Business Intelligence",
    ],
    "Design": [
      "UI/UX Design",
      "Graphic Design",
      "Product Design",
    ],
    "Marketing": [
      "Digital Marketing",
      "SEO/SEM",
      "Content Writing",
      "Social Media",
    ],
    "Management": [
      "Project Management",
      "Product Management",
      "Business Analysis",
    ],
    "Finance": [
      "Accounting",
      "Financial Analysis",
      "Auditing",
    ],
    "HR": [
      "Recruitment",
      "Talent Acquisition",
      "HR Operations",
    ],
    "Support": [
      "Customer Support",
      "Technical Support",
    ],
    "Legal": [
      "Legal Advisory",
      "Compliance",
    ],
    "Others": [
      "General Administration",
      "Other",
    ]
  };
  const getDefaultFormData = () => ({
  title: "",
  description: "",
  min_salary: "",
  max_salary: "",
  currency_salary: "",
  job_location: "",
  work_mode: "",
  requirements: "",
  no_of_vacancies: "",
  min_experience_required: "",
  max_experience_required: "",
  availability: "",
  deadline: "",

  category: "",
  specialization: "",
  status: "Draft",

  // 🔽 ADD THESE (VERY IMPORTANT)
  posting_type: "",        // Permanent | Contract | Walk-in
  employment_type: "",     // Full Time | Part Time
  venue_address: "",       // only for Walk-in
  post_type: "post_now",   // post_now | schedule
  scheduled_at: "",        // date
  expiry_date: "",         // date

  createdBy: localStorage.getItem("uId"),
  updatedBy: "",
  company_id: localStorage.getItem("companyId"),
  employer_id: localStorage.getItem("aUid"),
});

  
  const copiedJob = location.state?.copiedJob;

  const [formData, setFormData] = useState({   
    ...getDefaultFormData(),
    ...initialValues, // For edit mode to override
    ...copiedJob,
  });

  useEffect(() => {
    if (isEdit && id) {
      const fetchJob = async () => {
        try {
         
          const response = await jbAPI.get(`/employer/jobs/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setFormData(response.data.job); // adjust based on API response shape
        } catch (error) {
          console.error("Failed to fetch job data:", error);
        }
      };
      fetchJob();
    }
  }, [isEdit, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ 
          ...prev, 
          [name]: value,
          ...(name === "category" && { specialization: "" }) // Reset specialization on category change
     }));
  };

  const handleClearButtonClick = () => {
    setFormData(getDefaultFormData());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const url = isEdit ? `/employer/job/${id}/update` : `/employer/job/create`;
    const methodFn = isEdit ? jbAPI.put : jbAPI.post; // Function reference, not a string
    const payload = { ...formData };

    // Add createdBy or updatedBy based on isEdit flag
    const appUserId = localStorage.getItem("aUId");
    if (isEdit) {
      payload.updatedBy = appUserId;
      delete payload.createdBy; // Remove if present
    } else {
      setFormData(getDefaultFormData());
      payload.createdBy = appUserId;
      delete payload.updatedBy; // Remove if present
    }

    try {
      const res = await methodFn(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("otoken")}`,
        },
      });
  
      if (res.status === 200 || res.status === 201) {
        // alert(isEdit ? "Job updated!" : "Job posted!");
        setMessage({
          type: "success",
          text: isEdit ? "Job updated!" : "Job posted!"
        });
        
      } else {
        throw new Error("Unexpected response");
      }
    } catch (err) {
      console.error(err);
      // alert("Failed to submit the job");
      setMessage({ type: "danger", text: "Failed to submit the job" });
    }
  };
  const navigate = useNavigate();
  
  return (
    <div className="content-body">
      {/* <div className="row page-titles mx-0">
        <div className="col p-md-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="javascript:void(0)">Manage Jobs</a>
            </li>
            <li className="breadcrumb-item active">
              <a href="javascript:void(0)">Edit Job</a>
            </li>
          </ol>
        </div>
      </div> */}
      
      <div className="container-fluid">
        <h2>{isEdit ? "Edit Job" : "Post New Job"}</h2>
        <div className="row justify-content">
            <div className={`alert alert-${message.type} mt-3`} role="alert">
                          {message.text}
                  </div>
          <div className="col-lg-3">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Posting Details</h4>
                    <div className="form-validation">
                    <form className="form-validate" onSubmit={handleSubmit}>
                      <div className="form-group row">                        
                            <label className="radio-inline mr-3">
                            <input
                              type="radio"
                              name="posting_type"
                              value="Permanent"
                              checked={formData.posting_type === "Permanent"}
                              onChange={handleChange}
                            /> Permanent
                          </label>

                          <label className="radio-inline mr-3">
                            <input
                              type="radio"
                              name="posting_type"
                              value="Contract"
                              checked={formData.posting_type === "Contract"}
                              onChange={handleChange}
                            /> Contract
                          </label>

                          <label className="radio-inline">
                            <input
                              type="radio"
                              name="posting_type"
                              value="Walk-in"
                              checked={formData.posting_type === "Walk-in"}
                              onChange={handleChange}
                            /> Walk-in
                          </label>
                    
                      </div>
                      {/* Only for Walk-in */}
                      {formData.posting_type === "Walk-in" && (
                        <div className="form-group row">
                          <label>Venue Address</label>
                          <textarea
                            className="form-control h-150px"
                            name="venue_address"
                            value={formData.venue_address}
                            onChange={handleChange}
                          />
                        </div>
                      )}

                      {/* Only for Permanent job */}
                      <div className="form-group row">                  
                            <label className="radio-inline mr-3">
                            <input
                              type="radio"
                              name="employment_type"
                              value="Full Time"
                              checked={formData.employment_type === "Full Time"}
                              onChange={handleChange}
                            /> Full Time
                          </label>

                          <label className="radio-inline mr-3">
                            <input
                              type="radio"
                              name="employment_type"
                              value="Part Time"
                              checked={formData.employment_type === "Part Time"}
                              onChange={handleChange}
                            /> Part Time
                          </label>
                                            
                      </div>
                      {/* Only for Permanent & Contract job */}
                      <div className="form-group row">
                          <label>Schedule job post</label>
                      </div>
                      <div className="form-group row">                                     
                        <label className="radio-inline mr-3">
                        <input
                          type="radio"
                          name="post_type"
                          value="Immediate"
                          checked={formData.post_type === "Immediate"}
                          onChange={handleChange}
                        /> Post now
                      </label>

                      <label className="radio-inline mr-3">
                        <input
                          type="radio"
                          name="post_type"
                          value="Scheduled"
                          checked={formData.post_type === "Scheduled"}
                          onChange={handleChange}
                        /> Choose a date
                      </label>
                                           
                    </div>
                      
                     {/* Only for Choose a date */}
                      {formData.post_type === "Scheduled" && (
                          <div className="form-group row">
                            <input
                              type="date"
                              className="form-control"
                              name="scheduled_at"
                              value={formData.scheduled_at}
                              onChange={handleChange}
                            />
                          </div>
                        )}

                      {/* Only for Permanent & Contract job */}
                      <div className="form-group row">
                          <label>Expiry Date</label>    
                          <div className="input-group">
                            <input
                              type="date"
                              className="form-control"
                              name="expiry_date"
                              value={formData.expiry_date}
                              onChange={handleChange}
                            />
                            {/* <span className="input-group-append">
                              <span className="input-group-text">
                                <i className="mdi mdi-calendar-check"></i>
                              </span>
                            </span> */}
                          </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <br/>
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Recruiter Information</h4>
                    <div>                   
                        <h4 className=" text-dark mt-3"><i className="fa fa-user"></i>  {fullName}</h4>
                        <p className="text-muted">{email}</p>
                    </div>
                    <div>                        
                        <h4 className=" text-dark mt-3"><i className="fa fa-building"></i> {companyName}</h4>
                    </div>
              </div>               
            </div>
          </div>
         
          <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
              
                  <h4 className="card-title">Job Details</h4>
                
                    <div className="form-validation">
                    <form className="form-validate" onSubmit={handleSubmit}>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="username">
                          Job Title <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control"
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            placeholder="Enter a username.."
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="username">
                          Job Description <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="5"
                            placeholder="What would you like to see?"
                          ></textarea>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="requirements">
                        Requirements <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <textarea
                            className="form-control"
                            id="requirements"
                            name="requirements"
                            value={formData.requirements}
                            onChange={handleChange}
                            rows="5"
                            placeholder="What would you like to see?"
                          ></textarea>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="min-max-salary">
                          Salary Range <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-2">
                          <input
                            type="text"
                            className="form-control"
                            id="currency_salary"
                            name="currency_salary"
                            value={formData.currency_salary}
                            onChange={handleChange}
                            placeholder="Minimum salary"
                          />
                        </div>
                        <div className="col-lg-2">
                          <input
                            type="text"
                            className="form-control"
                            id="min_salary"
                            name="min_salary"
                            value={formData.min_salary}
                            onChange={handleChange}
                            placeholder="Minimum salary"
                          />
                        </div>
                        <div className="col-lg-2">
                          <input
                            type="text"
                            className="form-control"
                            id="max_salary"
                            name="max_salary"
                            value={formData.max_salary}
                            onChange={handleChange}
                            placeholder="Minimum salary"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="job_location">
                          Job Location <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-2">
                          <input
                            type="text"
                            className="form-control"
                            id="job_location"
                            name="job_location"
                            value={formData.job_location}
                            onChange={handleChange}
                            placeholder="Enter job location"
                          />
                        </div>
                        <label className="col-lg-4 col-form-label" htmlFor="job_location">
                          Work Mode <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-2">
                          <select 
                            className="form-control"
                            id="work_mode"
                            name="work_mode"
                            value={formData.work_mode || ""} // bind to state
                            onChange={handleChange}
                            placeholder="Enter job location"
                          >
                              <option value="">Select</option>
                              <option value="Remote">Remote</option>
                              <option value="Onsite">Onsite</option>
                              <option value="Hybrid">Hybrid</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="no_of_vacancies">
                        Number of Vacancies <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control"
                            id="no_of_vacancies"
                            name="no_of_vacancies"
                            value={formData.no_of_vacancies}
                            onChange={handleChange}
                            min="1"
                            placeholder="Enter Number of Vacancies"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="availability">
                        Availability <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            className="form-control"
                            id="availability"
                            name="availability"
                            value={formData.availability || ""} // bind to state
                            onChange={handleChange}
                            placeholder="Enter availability"
                          >
                              <option value="">-- Select Availability --</option>
                              <option value="Immediate Joiner">Immediate Joiner</option>
                              <option value="Within 1 Week">Within 1 Week</option>
                              <option value="Within 2 Weeks">Within 2 Weeks</option>
                              <option value="Within 1 Month">Within 1 Month</option>
                              <option value="More than 1 Month">More than 1 Month</option>
                              <option value="Notice Period">Currently Employed – Need Notice Period</option>
                              <option value="Open to Opportunities">Open to Opportunities</option>
                              <option value="Freelance/Part-Time">Freelance / Part-Time Available</option>
                              <option value="Not Available">Not Available</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="min-max-experience">
                          Experience Range <span className="text-danger">*</span>
                        </label>                      
                        <div className="col-lg-2">
                          <input
                            type="text"
                            className="form-control"
                            id="min_experience_required"
                            name="min_experience_required"
                            value={formData.min_experience_required}
                            onChange={handleChange}
                            placeholder="Minimum Experience"
                          />
                        </div>
                        <div className="col-lg-2">
                          <input
                            type="text"
                            className="form-control"
                            id="max_experience_required"
                            name="max_experience_required"
                            value={formData.max_experience_required}
                            onChange={handleChange}
                            placeholder="Maximum Experience"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="deadline">
                        Application Deadline <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="date"
                            className="form-control"
                            id="deadline"
                            name="deadline"
                            value={formData.deadline}
                            onChange={handleChange}
                            />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="category">
                        Category <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            className="form-control"
                            id="category"
                            name="category"
                            value={formData.category || ""} // bind to state
                            onChange={handleChange}   // ✅ needed to track state
                          >
                            <option value="">-- Select Job Category --</option>
                            <option value="Information Technology">Information Technology</option>
                            <option value="Software Development">Software Development</option>
                            <option value="Data Science & Analytics">Data Science & Analytics</option>
                            <option value="Design & Creative">Design & Creative</option>
                            <option value="Marketing & Advertising">Marketing & Advertising</option>
                            <option value="Sales & Business Development">Sales & Business Development</option>
                            <option value="Customer Support">Customer Support</option>
                            <option value="Finance & Accounting">Finance & Accounting</option>
                            <option value="Human Resources">Human Resources</option>
                            <option value="Education & Training">Education & Training</option>
                            <option value="Healthcare">Healthcare</option>
                            <option value="Legal">Legal</option>
                            <option value="Engineering">Engineering</option>
                            <option value="Operations & Supply Chain">Operations & Supply Chain</option>
                            <option value="Administrative">Administrative</option>
                            <option value="Construction">Construction</option>
                            <option value="Real Estate">Real Estate</option>
                            <option value="Hospitality & Travel">Hospitality & Travel</option>
                            <option value="Media & Communication">Media & Communication</option>
                            <option value="Public Relations">Public Relations</option>
                            <option value="Government & Public Sector">Government & Public Sector</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="specialization">
                        Specialization <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                        <select
                            name="specialization"
                            className="form-control"
                            value={formData.specialization || ""} // bind to state
                            onChange={handleChange}
                            disabled={!formData.category}
                          >
                            <option value="">-- Select Specialization --</option>
                            {(categorySpecializations[formData.category] || []).map((spec, idx) => (
                              <option key={idx} value={spec}>{spec}</option>
                            ))}
                          </select>

                        </div>
                      </div>
                      
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="status">
                        Status <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            id = "status"
                            name="status"
                            value={formData.status || ""} // bind to state
                            className="form-control"
                          
                            onChange={handleChange}
                            >
                              <option value="">-- Select Status --</option>
                              <option value="Draft">Draft</option>
                              <option value="Active">Active</option>
                              <option value="Expired">Expired</option>
                              <option value="Closed">Closed</option>
                          </select>
                        </div>
                      </div>
                      
                      <div className="col-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-secondary mr-2"
                          onClick={() => navigate("/employer/job-management/all-jobs")}
                        >
                          Cancel
                        </button>
                        {!isEdit && (
                          <button
                            type="button"
                            className="btn btn-warning mr-2"
                            onClick={handleClearButtonClick}
                          >
                            Clear
                          </button>
                        )}

                        
                        <button type="submit" className="btn btn-primary ">
                          {isEdit ? "Update Job" : "Post Job"}
                        </button>

                      </div>
                      
                    </form>
                
                  </div>
                
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobForm;
